import { I18nLocale, t } from '@ardoq/i18n';

/**
 * The string values below are persisted into saved filter subqueries (see
 * `mapFilterModelToSubquery`) and round-tripped back from the backend, so they
 * MUST remain English identifiers. Display labels are derived from these
 * identifiers via `getFilterOptionLabel`.
 */
export const predefinedSelectOptions = {
  noReferences: 'No references',
  hasReferences: 'Has references',
};

export const noValueSelectOption = 'No value';
export const hasValueSelectOption = 'Has value';

export const getFilterOptionLabel = (
  value: string,
  i18nLocale: I18nLocale
): string => {
  if (value === noValueSelectOption) {
    return t(i18nLocale, 'inventoryApp:ag.filter.option.noValue', 'No value');
  }
  if (value === hasValueSelectOption) {
    return t(i18nLocale, 'inventoryApp:ag.filter.option.hasValue', 'Has value');
  }
  if (value === predefinedSelectOptions.noReferences) {
    return t(
      i18nLocale,
      'inventoryApp:ag.filter.option.noReferences',
      'No References'
    );
  }
  if (value === predefinedSelectOptions.hasReferences) {
    return t(
      i18nLocale,
      'inventoryApp:ag.filter.option.hasReferences',
      'Has References'
    );
  }
  return value;
};

const disabledFilter = {
  filter: false,
};

const getDisabledFilter = () => disabledFilter;

export const agGridFilterOperations = {
  getDisabledFilter,
};
